import { Component, Input,Output,EventEmitter, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-imglist',
  templateUrl: './imglist.component.html',
  styleUrls: ['./imglist.component.less']
})
export class ImglistComponent implements OnInit {

  @Input() index!: number;
  @Output() indexChange = new EventEmitter<number>();

  constructor() { }
  Pages:any = [];
  @Input() Images:any;
  ngOnInit(): void {
    var i = -1;
    this.Images.forEach((x:any,index:number)=>{
      if((index)%5 === 0 || index === 0){
        this.Pages.push([]);
        i++;
      }
      this.Pages[i][index%5] = x.includes('http')?x:environment.storageurl+x;
      
    });
  }
  imgselect(int:number){
    this.index = int;
    this.indexChange.emit(this.index);
      }
}
